import React from "react";
import PropTypes from "prop-types";

import { spacingProps, spacingClass } from "../utilities/spacing";

import cn from "classnames";

const TableHead = (props) => {
  let { children, className, color, ...attributes } = props;

  let spacing;
  [spacing, attributes] = spacingClass(attributes);

  color = color ? `table-${color}` : "";

  return (
    <thead {...attributes} className={cn(color, spacing, className)}>
      {children}
    </thead>
  );
};

TableHead.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "danger",
    "light",
    "dark",
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  ...spacingProps(),
};

TableHead.defaultProps = {
  className: "",
};

export default TableHead;
